import { composeIO } from 'react-compose-io'
import { emTransitoInadimplenciaIO } from './EmTransitoInadimplencia.IO'
import { EmTransitoInadimplenciaView } from './EmTransitoInadimplencia.View'

export const EmTransitoInadimplencia = composeIO(EmTransitoInadimplenciaView, emTransitoInadimplenciaIO)
